import { ReactNode, useState } from "react";
import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";

import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { useNotificationContext } from "providers";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { parseErrorMessage } from "utils";

interface IProps {
  text?: string | ReactNode;
  successText?: string;
  buttonText?: string;
  cancelButtonText?: string;
  calledQuery: (id: string) => Promise<any>;
  onSuccess?: () => void;
  fullWidth?: boolean;
  textAlign?: "start" | "center" | "end";
  closeModalFunction?: () => void;
}

export const confirmationModalConfigs = {
  centered: true,
  noValidation: true,
  width: "600px",
  title: "Подтвердите действие",
};

export const ConfirmationModal = observer((props: IProps) => {
  const {
    text,
    successText,
    buttonText,
    calledQuery,
    onSuccess,
    cancelButtonText,
    fullWidth,
    textAlign,
    closeModalFunction,
  } = props;
  const { actionModals, userCard } = useStores();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const { openNotification } = useNotificationContext();

  const userId = userCard.card.id;

  const closeModal = () => {
    if (closeModalFunction) {
      closeModalFunction();
    } else {
      actionModals.closeAll();
    }
  };

  const handleClick = () => {
    setLoading(true);
    calledQuery(userId)
      .then(() => {
        onSuccess?.();
        setSuccess(true);
        actionModals.closeAll();
        openNotification({
          message: successText ?? "Успешно",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
      })
      .catch((e) => {
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Flex vertical align={textAlign ?? "center"} gap="middle" justify={textAlign ?? "center"}>
        {text && <Typography.Text>{text}</Typography.Text>}

        <Flex gap="middle" className={`margin-top-lgz ${fullWidth ? "full-width" : ""}`}>
          <CustomButton
            htmlType="submit"
            disabled={loading || success}
            loading={loading}
            onClick={handleClick}
            className={fullWidth ? "full-width" : ""}
          >
            {buttonText ?? "ОК"}
          </CustomButton>
          <CustomButton
            htmlType="button"
            disabled={loading || success}
            loading={loading}
            type="default"
            onClick={closeModal}
            className={fullWidth ? "full-width" : ""}
          >
            {cancelButtonText ?? "Отмена"}
          </CustomButton>
        </Flex>
      </Flex>
    </>
  );
});
